import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { defaultMemoize } from 'reselect';
export var getColumnsWithActions = defaultMemoize(function (columns, actionConfig) {
  return [].concat(_toConsumableArray(columns), [actionConfig]);
});